import { LitElement } from 'lit';
import { customElement } from 'lit/decorators.js';

import './components/header';
import './components/app-tabs';
import './styles/global.css';
import { getRouteTitle, router } from './router';

@customElement('app-index')
export class AppIndex extends LitElement {
  private readonly updateDocumentTitle = () => {
    document.title = getRouteTitle();
  };

  firstUpdated() {
    router.addEventListener('route-changed', () => {
      this.updateDocumentTitle();
      if ('startViewTransition' in document) {
        (document as any).startViewTransition(() => this.requestUpdate());
      } else {
        this.requestUpdate();
      }
    });
    window.addEventListener('langchange', this.updateDocumentTitle);
    this.updateDocumentTitle();
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    window.removeEventListener('langchange', this.updateDocumentTitle);
  }

  render() {
    // Конфигурация маршрутов — в src/router.ts
    return router.render();
  }
}
